<template>
  <aside class="col-lg-7 animated fadeInRight">
    <div class="mail-box-header">
      <h2>Lista de Pontos de interesse</h2>

      <form>
        <div class="input-group">
          <input type="text" class="form-control" v-model="form.pointName" />

          <div class="input-group-btn">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="searchPoints"
              v-if="permissionRead"
            >
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <!-- <th>Total de vagas</th> -->
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(listItem, listIdx) in pointsList.list" :key="listIdx">
            <td>{{ listItem.pointName }}</td>
            <!-- <td>{{ listItem.parkingSpaceCount }}</td> -->

            <td class="list-command">
              <button
                class="btn btn-outline"
                title="Inabilitar ponto de interesse"
                v-if="permissionUpdate"
                @click="enterEditMode(listItem)"
              >
                <i class="fa fa-edit text-success"></i>
              </button>
            </td>
            <td class="list-command">
              <button
                class="btn btn-outline"
                title="Excluir ponto de interesse"
                v-if="permissionDelete"
                @click="removePointOfInterest(listItem)"
              >
                <i class="fa fa-trash text-danger"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </aside>
</template>

<script>
import { toast } from '@/plugins/toast';
export default {
  data() {
    return {
      form: {
        pointName: '',
      },
      pointsList: {
        originalList: [],
        list: [],
      },
    };
  },

  computed: {
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'point-of-interest',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'point-of-interest',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'point-of-interest',
        'DELETE',
      );
    },
  },
  watch: {
    'form.pointName'() {
      this.searchPoints();
    },
  },

  mounted() {
    this.listPoints();
  },
  methods: {
    async listPoints() {
      try {
        if (!this.permissionRead) {
          return;
        }
        const pointsList = await this.$store.dispatch(
          'POINT-INTEREST/GetPointOfInterestList',
        );

        this.pointsList.originalList = pointsList.data;
        this.searchPoints();
      } catch (error) {
        toast.error('Falha ao listar pontos de interesse');
      }
    },
    searchPoints() {
      try {
        if (!this.permissionRead) {
          return;
        }

        const listFiltered = this.pointsList.originalList.filter((item) => {
          return (
            item.pointName
              .toUpperCase()
              .indexOf(this.form.pointName.toUpperCase()) > -1
          );
        });
        this.pointsList.list = listFiltered;
      } catch (error) {
        toast.error('Falha ao filtrar pontos de interesse');
      }
    },
    enterEditMode(data) {
      this.$emit('enterEditMode', data);
    },
    async removePointOfInterest({ _id }) {
      try {
        const pointOfInterestId = _id;
        await this.$store.dispatch(
          'POINT-INTEREST/RemovePointOfInterestList',
          pointOfInterestId,
        );
        this.listPoints();
        toast.success('Ponto de interesse removido com sucesso!');
      } catch (error) {
        toast.error('Falha ao remover pontos de interesse');
      }
    },
  },
};
</script>